import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  creditMemoApplyTable,
  creditMemoitemsTable,
} from "../../../config/grid-column-defs";
import {
  getTransactionCreditMemoItem,
  getTransactionVendorCreditApply,
} from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,
  Grid,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../../components/TabPanel";

export default function CreditMemoItems() {
  const [tabIndex, setTabIndex] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState("");
  const [taxCredit, setTaxCreditData] = useState("");

  const [itemsSum, setItemsSum] = useState("");
  const [applySum, setApplySum] = useState("");

  async function getTransactionCreditMemoItemData(limit = 10, offset = 0) {
    setLoading(true);
    try {
      const { data } = await getTransactionCreditMemoItem(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setItemsSum(data.data.itemsum);
      setRowData(data.data);
      setTaxCreditData(data.data.tax_credit);
      setLoading(false);
      return {
        rows: data.data.items,
        total: data.data.itemstotal,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      //snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getTransactionCreditMemoApplyData(limit = 10, offset = 0) {
    try {
      const { data } = await getTransactionVendorCreditApply(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setApplySum(data?.data?.data[0]);
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      //setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox" style={{ height: "auto" }}>
        <Grid container p={1}>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">UNAPPLIED</p>
            <p className="tFormName">{rowData?.unapplied}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel checkAndTextAlign">
              {rowData?.tax_override === "T" ? (
                <>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox disabled checked />}
                      label=""
                    />
                  </FormGroup>
                  TAX OVERRIDE
                </>
              ) : (
                <>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox disabled />}
                      label=""
                    />
                  </FormGroup>
                  TAX OVERRIDE
                </>
              )}
            </p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">APPLIED</p>
            <p className="tFormName">{rowData?.applied}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel checkAndTextAlign">
              {rowData?.tax_date_override === "T"  ? (
                <>
                  <FormGroup>
                    <FormControlLabel
                    control={<Checkbox disabled checked />}
                      label=""
                    />
                  </FormGroup>
                  TAX DATE OVERRIDE
                </>
              ) : (
                <>
                  <FormGroup>
                    <FormControlLabel
                     control={<Checkbox disabled />}
                      label=""
                    />
                  </FormGroup>
                  TAX DATE OVERRIDE
                </>
              )}
            </p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">TAX CREDIT</p>
            <p className="tFormName">{rowData?.tax_credit}</p>
          </Grid>
          <Grid item xs={12} sm={6} className="m-b-10">
            <p className="tFormlabel">AVATAX OVERRIDE DATE</p>
            <p className="tFormName">{rowData?.avatax_override_date}</p>
          </Grid>
        </Grid>
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label={`Items ${itemsSum || "0.00"}`} />
          <Tab label={`Apply ${applySum?.original_amt || "0.00"}`} />
        </Tabs>
        {/*----------Messages------------*/}
        <Box
          sx={{
            width: "100%",
            overflowX: "auto",
            padding: 2,
            boxSizing: "border-box",
            "@media (max-width:600px)": {
              padding: 1,
            },
          }}
        >
          <TabPanel value={tabIndex} index={0}>
          
              <AgGridPaginatedTable
                getTableRows={getTransactionCreditMemoItemData}
                columns={creditMemoitemsTable}
                refreshCounter={0}
              />
          
          </TabPanel>
        </Box>
        <Box
          sx={{
            width: "100%",
            overflowX: "auto",
            padding: 2,
            boxSizing: "border-box",
            "@media (max-width:600px)": {
              padding: 1,
            },
          }}
        >
          <TabPanel value={tabIndex} index={1}>
          
              <AgGridPaginatedTable
                getTableRows={getTransactionCreditMemoApplyData}
                columns={creditMemoApplyTable}
                refreshCounter={0}
              />
          
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
